import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="payment-method-selector"
export default class extends Controller {
  static targets = ["stripeElementContainer", "mercadopagoFormContainer", "savedMethodInput"]

  connect() {
    console.log("Payment method selector controller connected")
  }

  // Toggle between saved and new payment methods
  togglePaymentMethod(event) {
    const type = event.currentTarget.dataset.type
    const savedId = event.currentTarget.dataset.savedId

    if (type === 'new') {
      this.showNewCardForm()
    } else if (type === 'saved') {
      this.showSavedCard(savedId)
    }
  }

  showNewCardForm() {
    // Show Stripe Payment Element for new card
    if (this.hasStripeElementContainerTarget) {
      this.stripeElementContainerTarget.classList.remove('hidden')
    }

    // Show MercadoPago form for new card
    if (this.hasMercadopagoFormContainerTarget) {
      this.mercadopagoFormContainerTarget.classList.remove('hidden')
    }

    // Disable all saved payment method hidden inputs
    this.savedMethodInputTargets.forEach(input => {
      input.disabled = true
    })
  }

  showSavedCard(savedId) {
    // Hide Stripe Payment Element
    if (this.hasStripeElementContainerTarget) {
      this.stripeElementContainerTarget.classList.add('hidden')
    }

    // Hide MercadoPago form
    if (this.hasMercadopagoFormContainerTarget) {
      this.mercadopagoFormContainerTarget.classList.add('hidden')
    }

    // Enable only the selected saved payment method hidden input
    this.savedMethodInputTargets.forEach(input => {
      const inputSavedId = input.dataset.savedId
      input.disabled = (inputSavedId !== savedId)
    })
  }
}
